import { useCustomTerms } from "../hooks/useCustomTerms";

export interface TermsProps {
  gogovTermsUrl: string;
  cityTermsUrl: string;
  cityName: string;
}
export const Terms = () => {
  const { goGovTermsUrl, cityTermsUrl, cityName } = useCustomTerms();
  if (!cityTermsUrl) {
    return (
      <div className='tw-p-4 tw-text-center'>
        <p>
          By signing in or creating an account, you agree to{" "}
          <a className='tw-font-bold tw-text-blue' rel='noopener noreferrer' href={goGovTermsUrl} target='_blank'>
            our terms
          </a>
        </p>
      </div>
    );
  }
  return (
    <div className='tw-p-4 tw-text-center'>
      <p>
        By signing in or creating an account, you agree to the terms for{" "}
        <a className='tw-font-bold tw-text-blue' rel='noopener noreferrer' href={goGovTermsUrl} target='_blank'>
          GOGov
        </a>{" "}
        and{" "}
        <a className='tw-font-bold tw-text-blue' rel='noopener noreferrer' target='_blank' href={cityTermsUrl}>
          {cityName}
        </a>
      </p>
    </div>
  );
};
